import ReactHtmlParser from 'react-html-parser'; 

var PaywallModal = require("components/users/teachers/PaywallModal");
var Glyphicon = require("components/utility/icons/Glyphicon");
var CurrentUser = require("lib/account/CurrentUser");
var Spinner = require("components/utility/Spinner");
var Modal = require("components/utility/AltModal");
var GoldTrialModal = require('components/trials/GoldTrialModal.js')
var AccountPlans = require("lib/account/AccountPlans");

require("notifications/site_banner.scss");

class SiteBanner extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			loading: false, paywallType: null
		};

		this.goldTrialModal = React.createRef();
	}

	deleteAlert(alertID) {
		this.setState({ loading: true });
		CurrentUser.api().deleteUserAlert(alertID, $wr.apiHandler(function(response) {
			CurrentUser.fetchCurrentUserData(function() {
				this.setState({ loading: false });
			}.bind(this));
		}.bind(this)));
	}

	userAlert() {
		return _.last(_.sortBy(this.props.alerts, "created_at"));
	}

	openPaywall(e) {
		$wr.nope(e)
		var userAlert = this.userAlert();

		Mycroft.newEvent({
			category: "Notifications", action: "site-banner-cta-click", label: userAlert.data.cta_action
		})

		var paywallType = userAlert.data.cta_action.split(":")[1];
		this.setState({ paywallType: paywallType }, function() {
			this.refs.paywallModal.show();
		}.bind(this));
	}

	renderGoldTrialModal() {
		return (
			<Modal headerText="Unlock Gold Free for 60 Days" ref={this.goldTrialModal}>
				<GoldTrialModal alertID={this.userAlert().id} />
			</Modal>
		);
	}

	render() {
		var userAlert = this.userAlert();

		var ctaText = userAlert.data.cta_text || "Learn More";
		if (userAlert.data.cta_action && userAlert.data.cta_url) {
			if (SiteBanner.PAYWALL_LINK_REGEX.test(userAlert.data.cta_action)) {
				var alertButton = (
					<a href="#" className="buttonSuccess alertButton" onClick={ this.openPaywall }>
						{ ctaText }
					</a>
				);
			}

		} else if (userAlert.data.cta_url) {
			var alertURL = userAlert.data.cta_url;
			var linkEventHandler = Mycroft.buildEventHandler({
				category: "Notifications", action: "site-banner-cta-click", label: alertURL
			});

			var alertButton = (
				<a href={ alertURL } className="buttonSuccess alertButton" target="_blank"
					onClick={ linkEventHandler }>
					{ ctaText }
				</a>
			);
		}

		if (this.state.loading) {
			var removeLink = (<Spinner className="removeLink" placeholder={ false } scale={ 1 } />);
		} else {
			var removeLink = (
				<a href="#" onClick={ this.deleteAlert.bind(this, userAlert.id) }
					className="removeLink">
					<Glyphicon icon="remove" />
				</a>
			);
		}

		var numAlerts = this.props.alerts.length;
		if (numAlerts > 1) {
			var multiAlertText = (
				<div className="alertNumber">
					1 of { numAlerts }
				</div>
			);
		}

		if (this.state.paywallType) {
			var paywallModal = ( 
				<PaywallModal ref="paywallModal" featureType={ this.state.paywallType } /> 
			);
		}

		var contentClass = 'content'
		var siteBannerContainerClass = 'siteBannerContainer'
		if (userAlert.data.feature === AccountPlans.PRODUCTS.WR_GOLD) {
			LuckyOrangeClient.tagComponent("SiteBannerGoldTrial");
			contentClass += ' gold'
			siteBannerContainerClass += ' goldBackground'
			if (!alertButton && userAlert.data && userAlert.data.cta_text && userAlert.data.cta_text.length > 0) {
				var actionText = userAlert.data.cta_text !== undefined ? userAlert.data.cta_text : 'Start Today'

				// actionLink = (
				// 	<button className='btn btn-default goldTrialBannerCTA' onClick={() => this.goldTrialModal.current.show()}>
				// 		{actionText}
				// 	</button>
				// )
				var alertButton = (
					<a onClick={() => this.goldTrialModal.current.show()} className="btn btn-default goldTrialBannerCTA">
						{actionText}
					</a>
				);
			}
		}

		return (
			<div className={ siteBannerContainerClass }>
				<div className="container">
					<div className={ contentClass }>
						<div className="alertText">
							<strong>{ReactHtmlParser(userAlert.title)}</strong>
						</div>
						{ removeLink }
						{ alertButton }
						{ multiAlertText }
					</div>
				</div>
				{ paywallModal }
			</div>
		);
	}
};

SiteBanner.propTypes = StrictPropTypes({
	alerts: PropTypes.array.isRequired,
});

SiteBanner.PAYWALL_LINK_REGEX = /PAYWALL:[\w-]+/;

module.exports = SiteBanner;



// WEBPACK FOOTER //
// ./modules/components/notifications/SiteBanner.js